import {
  type QueueIncidentErrorConfig,
  type QueueIncidentErrorHandler,
} from '@collector/desktop-feature-incidents-queue-core'
import { SoccerIncidentId } from '@collector/sportsapi-client-legacy'

const isInjuryTimeError: QueueIncidentErrorHandler = (
  error: unknown,
): boolean => {
  if (error instanceof Error) {
    /**
     * Note that this API error message is misleading:
     * - The error is actually caused by an unsupported event status for `AddedTime` `display_info` changes, not the injury time data itself
     * - Even when the error occurs, PATCH of `display_info` is persisted in the API incident
     * - In the future, the API should resolve this error on their side, and this code can be removed
     */
    return error.message.includes(
      'Cannot save injury time for the current event status',
    )
  }
  return false
}

export const queueIncidentErrorConfig: QueueIncidentErrorConfig<SoccerIncidentId> =
  new Map([[SoccerIncidentId.AddedTime, isInjuryTimeError]])
